import React from 'react'
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import Search from '../../form/form-search'
import Text from '../../form/form-text'

class ModuleIframe extends React.Component {

    constructor(props){
        super(props)
        this.state = {
            data: this.props,
            disabled: this.props.disabled
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps, nextState) {
        this.setState({disabled: nextProps.disabled})
    }

    render() {
        let { thirdAppId } = this.state.data;
        let { disabled } = this.state;

        return <div className="module-iframe">
            { !disabled && <Search label="app.modules.iframe.search" onChange={ console.log } onSelect={ console.log }/> }
            { disabled && <Text disabled={true} label="app.modules.iframe.search" value={thirdAppId} /> }
        </div>;
    }
}

ModuleIframe.propTypes = {
    onChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool, // souhld be .isRequired,
    isCustom: PropTypes.bool, // souhld be .isRequired,
    thirdAppId: PropTypes.string
}

export default ModuleIframe;
